import Icon from '../components/Icon.vue'

Icon.register({
  fan: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M352.6 128c81.8 0 149.3 61.6 159.3 141.3 1.3 10.5-7.2 19.6-17.6 18.6l-123.1-12.4c8.3 23 12.9 49 12.9 77.1 0 81.8-61.6 149.3-141.3 159.3-10.5 1.3-19.6-7.2-18.6-17.6l12.4-123.1c-23 8.3-49 12.9-77.1 12.9-81.8 0-149.3-61.6-159.3-141.3-1.3-10.5 7.2-19.7 17.6-18.6l123.1 12.4c-8.3-23-12.9-49-12.9-77.1 0-81.8 61.6-149.3 141.3-159.3 10.5-1.3 19.7 7.2 18.6 17.6l-12.4 123.1c23-8.3 49-12.9 77.1-12.9zM256 288c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/fan.js
// module id = 1316
// module chunks = 0